import {Injectable, inject} from '@angular/core'
import type {CanActivate} from '@angular/router'
import {InfoService} from '../info.service'
import {NavigationService} from '../navigation.service'
import {NetWatchService} from '../net-watch.service'

@Injectable({
  providedIn: 'root',
})
export class NoInternetGuard implements CanActivate {
  readonly #infoService = inject(InfoService)
  readonly #netWatchService = inject(NetWatchService)
  readonly #navigationService = inject(NavigationService)

  async canActivate(): Promise<boolean> {
    const showNoInternetInitError = !this.#infoService.isWeb() && !this.#netWatchService.hasInternet()
    if (showNoInternetInitError) {
      this.#navigationService.navigateRoot('/no-internet')
      return false
    }
    return true
  }
}
